import { render, staticRenderFns } from "./project-manager.vue?vue&type=template&id=0d45f424&scoped=true&"
import script from "./project-manager.vue?vue&type=script&lang=js&"
export * from "./project-manager.vue?vue&type=script&lang=js&"
import style0 from "./project-manager.vue?vue&type=style&index=0&id=0d45f424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45f424",
  null
  
)

export default component.exports